// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__PEEh4","item":"Carousel_item__5eSl1","item-activated":"Carousel_item-activated__IJriY","tab-after":"Carousel_tab-after__D9buF"};